import React, { useState } from "react";
import iopexLogo from "../assets/images/iopex.webp";
import { useNavigate, useLocation } from "react-router-dom";

function HowWeDo() {
  const [activeTab, setActiveTab] = useState("orchestration");
  const navigate = useNavigate();

  return (
    <div className="how-page">
      {/* Top-left logo */}
      <header className="whyus-header">
        <img src={iopexLogo} alt="iOPEX Logo" className="whyus-logo" />
      </header>

      {/* Page Title */}
      <h1 className="how-title">Integrated Service Capabilities</h1>

      {/* Tabs */}
      <div className="how-tab-container">
        <div className="how-tab-wrapper">

        <button
            className="how-tab"
            onClick={() => navigate("/ad-touchpoints")}
          >
            Ad Touchpoints
          </button>

          
          <button
            className={`how-tab ${activeTab === "orchestration" ? "active" : ""}`}
            onClick={() => setActiveTab("orchestration")}
          >
            Orchestration Layer
          </button>
          

        </div>
      </div>

      {/* Cards Section */}
      <div className="how-cards">
        {/* Card 1 */}
        <div className="how-card-group">
          <h2 className="how-card-title">Media Monetization (360 Approach)</h2>
          <div className="how-card">
            <ul>
              <li>Inventory forecasting & allocation</li>
              <li>Dynamic pricing & yield management</li>
              <li>Advertiser acquisition & onboarding</li>
              <li>Campaign setup & trafficking</li>
              <li>Real-time pacing & optimization</li>
              <li>Performance reporting & insights</li>
              <li>Billing, invoicing & reconciliation</li>
              <li>Supplier & vendor management</li>
            </ul>
          </div>
        </div>

        {/* Card 2 */}
        <div className="how-card-group">
          <h2 className="how-card-title">Integrated Marketing (Full-Funnel)</h2>
          <div className="how-card">
            <ul>
              <li>Commerce media strategy & positioning</li>
              <li>Programmatic DSP integration & buying</li>
              <li>Media mix modeling & optimization</li>
              <li>Advertiser value proposition development</li>
              <li>Audience segmentation & targeting</li>
              <li>Competitive analysis & benchmarking</li>
              <li>Omnichannel campaign orchestration</li>
              <li>Attribution & incrementality testing</li>
            </ul>
          </div>
        </div>

        {/* Card 3 */}
        <div className="how-card-group">
          <h2 className="how-card-title">Innovation (CIO / CDO Enablement)</h2>
          <div className="how-card">
            <ul>
              <li>Ad tech stack architecture & deployment</li>
              <li>CDP integration (AdobeCDP, Salesforce)</li>
              <li>Microsoft Copilot & Agent Pay integration</li>
              <li>System integrations (100+ platforms)</li>
              <li>BI & analytics (Tableau, Power BI, Palantir)</li>
              <li>API development & data pipeline automation</li>
              <li>Clean room & privacy tech (LiveRamp, InfoSum)</li>
              <li>Agentic AI operations (LLMs, automation)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowWeDo;
